"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.resetPaginationQuery = void 0;
var resetPaginationQuery = function (searchParams, setSearchParams) {
    searchParams.set('page', '1');
    setSearchParams(searchParams);
};
exports.resetPaginationQuery = resetPaginationQuery;
